import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { userSelector } from "../features/authSlice";
import { Spin } from "antd";
import { AUTH_TOKEN_KEY } from "../constants";

const ADMIN_ROLES = ['user', 'admin'];

const PrivateRoute = ({ children }) => {
  const { id, isSuccess, isInitialized, role } = useSelector(userSelector);
  const location = useLocation();
  const token = localStorage.getItem(AUTH_TOKEN_KEY);

  // Spinner solo en carga inicial: hay token pero aún no se restauró la sesión
  if (token && !isInitialized && !isSuccess) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!id || !isSuccess) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!ADMIN_ROLES.includes(role)) {
    return <Navigate to="/portal" replace />;
  }

  return children || null;
};

export default PrivateRoute;
